import { BaseApiClient } from '../client'
import type { CreatorPost, CreateCreatorPostInput, PaginationMeta } from '../types'

export type PostStats = {
  totalPosts: number
  byType: Record<string, number>
  last30Days: number
}

export class CreatorPostsApi extends BaseApiClient {
  async list(
    creatorId: string,
    params?: { page?: number; limit?: number; platform?: string; type?: string }
  ): Promise<{ data: CreatorPost[]; meta: PaginationMeta }> {
    const query = new URLSearchParams()
    if (params?.page) query.append('page', params.page.toString())
    if (params?.limit) query.append('limit', params.limit.toString())
    if (params?.platform) query.append('platform', params.platform)
    if (params?.type) query.append('type', params.type)

    return this.requestPaginated<CreatorPost>(
      `/api/admin/creators/${creatorId}/posts${query.toString() ? `?${query}` : ''}`
    )
  }

  async getStats(creatorId: string): Promise<PostStats> {
    return this.request<PostStats>(`/api/admin/creators/${creatorId}/posts/stats`)
  }

  async create(data: CreateCreatorPostInput): Promise<CreatorPost> {
    return this.request<CreatorPost>('/api/admin/creator-posts', {
      method: 'POST',
      body: JSON.stringify(data),
    })
  }
}
